import { dataHooks as wixDataHooks } from '@wix/data-hooks'

export const dataHooks = wixDataHooks<{
  checkbox: {}
  image: {}
  name: {}
  builtInLabel: {}
  description: {}
}>('app-item')
